export default __webpack_public_path__ + "static/media/img17.e18f29a0.svg";